import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTryToCall } from '~/hooks';
import * as lib from '~/dependencies';
import { ArrowRightIcon, PhoneIcon, ExternalUrlIcon } from '~/assets/svgIcons';
import { openExternalURL } from '~/helpers';
import Report from '../Report';
import { Container, HelpItemsList, ReportProblemScene } from './styles';

import './styles.css';

const KNOWLEDGE_BASE_URL = 'https://support.nuacom.ie/hc/en-us';

export default function GetHelp() {
  const { t } = lib.useTranslation();
  const tryToCall = useTryToCall();

  const [calling, setCalling] = useState(false);
  const [showReportProblemScene, setShowReportProblemScene] = useState(false);

  const userInfo = useSelector(state => state.auth);

  function callSupport() {
    setCalling(true);
    setTimeout(() => {
      tryToCall(777);
    }, 1000);
  }

  return (
    <Container>
      {!showReportProblemScene ? (
        <HelpItemsList>
          <div
            className="row"
            role="presentation"
            onClick={() => openExternalURL(KNOWLEDGE_BASE_URL)}>
            <div>
              <span>
                {t('screens.configuration.components.getHelp.knowledgeBase')}
              </span>
            </div>
            <lib.ReactSVG src={ExternalUrlIcon} className="icon" />
          </div>
          <div
            className="row"
            role="presentation"
            onClick={() => setShowReportProblemScene(true)}>
            <div>
              <span>
                {t('screens.configuration.components.getHelp.reportProblem')}
              </span>
            </div>
            <lib.ReactSVG src={ArrowRightIcon} className="icon" />
          </div>
        </HelpItemsList>
      ) : (
        <ReportProblemScene>
          <div className="report-by-calling">
            <h3 className="title">
              {t('screens.configuration.components.getHelp.getHelpText')}
            </h3>
            <hr />
            <span className="description">
              {t('screens.configuration.components.getHelp.reachByCallingText')}
            </span>

            {!calling ? (
              <div className="call-for-help-buttom">
                <div aria-hidden="true" onClick={() => callSupport()}>
                  <span>
                    {' '}
                    {t(
                      'screens.configuration.components.getHelp.callingButtonText'
                    )}
                  </span>
                </div>
              </div>
            ) : (
              <div className="content-center">
                <div className="pulse">
                  <i>
                    <lib.ReactSVG src={PhoneIcon} className="icon" />
                  </i>
                </div>
              </div>
            )}

            <span className="description smaller-margin">
              {t('screens.configuration.components.getHelp.reachByFormText')}
            </span>

            <Report userInfo={userInfo} />
          </div>
        </ReportProblemScene>
      )}
    </Container>
  );
}
